import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-box';
import ProjectionStore from '../../../stores/ProjectionStore';
import { Toggle } from '../../common/Toggle';
import _ from 'lodash';

const getStateFromStores = () => {
  return {
    alertsAmountValue: ProjectionStore.getProjectionAlertsAmountValue(),
    notificationFlag: ProjectionStore.getProjectionAlertsNotificationBoolean(),
    selectedValue: '1',
    shakeSet: [],
  };
};
class AlertsNotificationsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.changeTheValue = this.changeTheValue.bind(this);
    this.dropdownList = this.dropdownList.bind(this);
    this.getPoundSymbol = this.getPoundSymbol.bind(this);
    this.shakeFields = this.shakeFields.bind(this);
    this.shakeZeroFields = this.shakeZeroFields.bind(this);
    this.state = getStateFromStores();
  }
  changeTheValue(e) {
    this.refs['overdraftAmount'].classList.add('shake');
    this.props.selectDropdown(e);
    this.refs['overdraftAmount'].classList.remove('shake');
  }
  dropdownList() {
    return (
      <div className="fc-select">
        <Select
          name="select"
          onChange={this.changeTheValue}
          value={this.props.selectedValue}
        >
          <option value="1">
            {this.props.content.projectionAlertsDropdownOption1}
          </option>
          <option value="2">
            {this.props.content.projectionAlertsDropdownOption2}
          </option>
        </Select>
      </div>
    );
  }
  getPoundSymbol() {
    if (this.props.dropdownSelection === 1) {
      return <label className="">&pound;</label>;
    } else if (this.props.dropdownSelection === 2) {
      return <label className="">-&pound;</label>;
    }
  }
  shakeFields(name) {
    this.refs[name].classList.add('shake');
    this.state.shakeSet.push(name);
    setTimeout(() => {
      this.state.shakeSet.map((item) => {
        if (this.refs[item] !== undefined) {
          this.refs[item].classList.remove('shake');
          this.refs['exceedFade'].classList.add('p-fade');
        }
        let result = _.without(this.state.shakeSet, item);

        this.setState({ shakeSet: result });
        this.props.shakeFalse();
      });
    }, 2000);
  }
  shakeZeroFields(name) {
    this.refs[name].classList.add('shake');
    this.state.shakeSet.push(name);
    setTimeout(() => {
      this.state.shakeSet.map((item) => {
        if (this.refs[item] !== undefined) {
          this.refs[item].classList.remove('shake');
          let result = _.without(this.state.shakeSet, item);
          this.setState({ shakeSet: result });
        }
      });
    }, 2000);
  }
  render() {
    if (this.props.shakeamount) {
      if (this.refs['exceedFade']) {
        this.refs['exceedFade'].classList.remove('p-fade');
      }
      this.shakeFields('overdraftAmount');
    }
    if (this.props.shakeamountZero) {
      this.shakeZeroFields('overdraftAmount');
    }
    return (
      <div className="full-height">
        <div className="settings-content-wrapper">
          <div className="row">
            <div className="col-xs-12">
              <div id="alerts-tab-container" className="text-center">
                <p className="tab-header">
                  {
                    this.props.content
                      .projectionSettingsAlertsAndNotificationsHeader
                  }
                </p>
                <div className="fc-alert-box">
                  <div className="alert-bell" />
                  <div className="currency-holder">
                    <h3 className="p-content first-line">
                      {
                        this.props.content
                          .projectionSettingsAlertsAndNotificationsContent
                      }
                    </h3>
                    <div className="currency">
                      {this.props.shakeamount ? (
                        <p ref="exceedFade">Overdraft exceeded</p>
                      ) : (
                        <p ref="exceedFade" />
                      )}
                      {this.getPoundSymbol()}
                      <input
                        type="text"
                        ref="overdraftAmount"
                        placeholder=""
                        value={this.props.alertsAmountValue}
                        onChange={this.props.changeTheValue}
                        className="face animated"
                      />
                    </div>
                    {this.dropdownList()}
                    <h3 className="p-content">
                      {
                        this.props.content
                          .projectionSettingsAlertsAndNotificationsFooter
                      }
                    </h3>
                    <div className="smsline">
                      <div className="toggle default">
                        <Toggle
                          defaultChecked={this.props.notificationFlag}
                          value={this.props.notificationFlag}
                          onChange={this.props.changeTheNotificationFlag}
                          aria-label="No label tag"
                        />
                      </div>
                      {
                        this.props.content
                          .projectionAlertAndNotificationsToggleText
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
AlertsNotificationsComponent.propTypes = {
  alertsAmountValue: PropTypes.string,
  changeTheValue: PropTypes.func,
  notificationFlag: PropTypes.bool,
  changeTheNotificationFlag: PropTypes.func,
  selectDropdown: PropTypes.func,
  content: PropTypes.object,
};

export default AlertsNotificationsComponent;
